import { SectionsInterface } from '../../field.interface';

export class Update32Layout {
	sections: SectionsInterface[] = [
		{
			title: 'Update',
			items: [
				[
					{
						cssClass: 'col-md-12',
						options: {
							path: 'InspectionReport.property.updates[{index}].description'
						}
					}
				]
			]
		}
	];
}
